import { Divider, Tab, Tabs, Typography } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export const DefaultSelection = ({ content }) => {
  console.log("Defaault selection", content);
  const { t, i18n } = useTranslation("main");
  const [selectedTab, setSelectedTab] = useState(0);
  const isMobile = window.innerWidth < 960;

  const handleChange = (_, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: isMobile ? "flex-end" : "center",
          gap: "1rem",
          marginTop: "0.5rem",
        }}
      >
        <Typography
          style={{
            whiteSpace: !isMobile ? "nowrap" : "",
            fontWeight: "bold",
            width: isMobile ? "min-content" : "",
          }}
        >
          {t("layer_groups")}:
        </Typography>
        <Tabs
          variant="scrollable"
          value={selectedTab}
          onChange={handleChange}
          aria-label="basic tabs example"
          TabIndicatorProps={{
            style: {
              backgroundColor: "var(--color-primary)",
            },
          }}
        >
          {content.map((tab) => (
            <Tab key={tab.id} label={tab.name[i18n.language]} />
          ))}
        </Tabs>
      </div>

      <Divider />
      {content[selectedTab]?.view?.$$typeof === Symbol.for("react.element")
        ? content[selectedTab].view
        : null}
    </>
  );
};
